export const getProviderName = (provider) => {
    switch (provider) {
        case 0:
            return "Total Processing";
        case 3:
            return "PaySafe";
        case 4:
            return "PaySafe";
        case 5:
            return "Paddle";
    }
}